import { Building2, LayoutGrid, Leaf, Sparkles, Home, Car, TreePine, ShieldCheck, Sun, Waves, Dumbbell, Wifi, KeyRound, Camera, Handshake, Eye, Clock, MapPin, Gem, RefreshCcw, LifeBuoy, Users, Award, HardHat, ClipboardCheck, Globe2, Ruler, Wallet, Wrench } from "lucide-react";

export const ICON_OPTIONS = [
  { value: "building-2", label: "Architecture", Icon: Building2 },
  { value: "layout-grid", label: "Balconies / Layout", Icon: LayoutGrid },
  { value: "leaf", label: "Landscaping", Icon: Leaf },
  { value: "sparkles", label: "Premium", Icon: Sparkles },
  { value: "home", label: "Home", Icon: Home },
  { value: "car", label: "Parking", Icon: Car },
  { value: "tree", label: "Greenery", Icon: TreePine },
  { value: "shield", label: "Security", Icon: ShieldCheck },
  { value: "sun", label: "Natural Light", Icon: Sun },
  { value: "waves", label: "Pool", Icon: Waves },
  { value: "gym", label: "Gym", Icon: Dumbbell },
  { value: "wifi", label: "Smart Home", Icon: Wifi },
  { value: "key", label: "Handover", Icon: KeyRound },
  { value: "camera", label: "Surveillance", Icon: Camera },
  { value: "handshake", label: "Partnership", Icon: Handshake },
  { value: "eye", label: "Transparency", Icon: Eye },
  { value: "clock", label: "On-time", Icon: Clock },
  { value: "map-pin", label: "Location", Icon: MapPin },
  { value: "gem", label: "Quality", Icon: Gem },
  { value: "refresh", label: "Updates", Icon: RefreshCcw },
  { value: "life-buoy", label: "Support", Icon: LifeBuoy },
  { value: "users", label: "Clients", Icon: Users },
  { value: "award", label: "Award", Icon: Award },
  { value: "hard-hat", label: "Construction", Icon: HardHat },
  { value: "clipboard", label: "Approvals", Icon: ClipboardCheck },
  { value: "globe", label: "NRI / Global", Icon: Globe2 },
  { value: "ruler", label: "Design", Icon: Ruler },
  { value: "wallet", label: "Value / Pricing", Icon: Wallet },
  { value: "wrench", label: "Maintenance", Icon: Wrench },
];

export const ICON_MAP = Object.fromEntries(ICON_OPTIONS.map((o) => [o.value, o.Icon]));

export function reorder(list, from, to) {
  const arr = [...list];
  const [moved] = arr.splice(from, 1);
  arr.splice(to, 0, moved);
  return arr;
}
